import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaStar, FaShoppingCart } from 'react-icons/fa';
import { useCart, products } from '../context/CartContext';

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const product = products.find((p) => p.id === parseInt(id));

  if (!product) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '80px 0' }}>
        <h2 style={{ color: '#00e5ff' }}>Produktet ble ikke funnet</h2>
        <p style={{ color: '#e0e0e0' }}>Det angitte produktet finnes ikke i vår katalog.</p>
      </div>
    );
  }

  const handleBuyNow = () => {
    addToCart(product);
    navigate('/checkout');
  };

  return (
    <div className="container product-detail">
      <Helmet>
        <title>{product.name} - HeroPixelLab</title>
        <meta name="description" content={product.description} />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org/',
            '@type': 'Product',
            name: product.name,
            description: product.description,
            brand: 'HeroPixelLab',
            offers: {
              '@type': 'Offer',
              priceCurrency: 'NOK',
              price: product.price,
              availability: 'https://schema.org/InStock'
            }
          })}
        </script>
        <link rel="canonical" href={`https://heropixellab.com/product/${product.id}`} />
      </Helmet>

      <div className="product-detail-container">
        <img src={product.image} alt={product.name} className="detail-image" />
        <div>
          <h1 className="detail-title">{product.name}</h1>
          <div className="product-rating">
            {[...Array(5)].map((_, index) => (
              <FaStar key={index} color={index < Math.floor(product.rating) ? '#ffd700' : '#555'} size={20} />
            ))}
            <span> {product.rating}</span>
          </div>
          <p className="detail-price">kr {product.price},-</p>
          <p className="detail-description">{product.description}</p>
          <div className="detail-buttons">
            <button className="detail-button add-to-cart" onClick={() => addToCart(product)}>
              <FaShoppingCart /> Legg i handlekurv
            </button>
            <button className="detail-button buy-now" onClick={handleBuyNow}>
              Kjøp nå
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '40px' }}>
        <h2 style={{ color: '#00e5ff', marginBottom: '20px' }}>Produktdetaljer</h2>
        <p className="about-text">
          {product.description} Med HeroPixelLab får du tilgang til spillet ditt umiddelbart etter kjøp. Produktet leveres som en digital nøkkel til din e-post. Du får full tilgang til alle funksjoner og fremtidige oppdateringer av spillet.
        </p>
        <p className="about-text">
          Våre spill har alltid de beste garantier. Dersom du skulle oppleve noen problemer, ta kontakt med vårt kundeservice-team innen 30 dager, så finner vi en løsning. Vi sikrer din tilfredshet med kvalitetsprodukter og pålitelig service.
        </p>
      </div>

      <div className="page-number">Side {product.id + 1}</div>
    </div>
  );
}

export default ProductDetail;